import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";

const AdminSchoolData = () => {
  
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    const fetchSchoolData = async () => {
      try {
        const response = await axios.get(`${config.API_BASE_URL}/Auth/GetSchoolData`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.status === 200) {
          // console.log("School data:", response.data.data);
        }
      } catch (error) {
        console.error("Error fetching school data:", error);
        // localStorage.removeItem("token");
        // localStorage.removeItem("schoolName");
        // navigate("/");
      }
    };

    fetchSchoolData();
  }, [navigate]);
};

export default AdminSchoolData;
